/*
 * Module for viewing Facade response data
*/

rs.module("controls/diagnostics/facadeviewer/responsedata",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            // Click handler for the close window button
            $.js(jsSelectors.closeButton).click(() => {
                window.close();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);